import { Box } from "@mui/material";
import { ReactNode } from "react";

export interface Props {
  children: ReactNode;
}

// A minimum, not a fixed height: the content column has to grow with the
// page so the sticky top bar inside it can follow the whole scroll, not just
// the first viewport. (It used to be 97vh, for a fixed header bar that no
// longer exists.) The nav is a fixed-position drawer and is unaffected.
const PAGE_MIN_HEIGHT = "100vh";

export const MainPageLayout = ({ children }: Props) => {
  return (
    <Box
      sx={{
        display: "flex",
        minHeight: PAGE_MIN_HEIGHT
      }}
      data-test-id="main-page-layout"
    >
      {children}
    </Box>
  );
};
